module.exports = __webpack_public_path__ + "img/25_47.741327a6.png";